"use strict";

import angular from "angular";

const name = "paddingLevel";
const factory = [
    () => ({
        restrict: "A",
        link: ($scope, $elem, $attr) => {
            const multiplier = Number($attr.paddingMultiplier) || 16;
            const definePadLeft = () => {
                const level = Number($attr.paddingLevel);
                const paddingLeft = (level + 1) * multiplier;
                $elem[0].style.paddingLeft = `${paddingLeft}px`;
            };
            definePadLeft();
            $scope.$watch(
                () => $attr.paddingLevel,
                (newValue) => {
                    if (newValue) definePadLeft();
                }
            );
        }
    })
];
angular.module("nucont.shared").directive(name, factory);
export default { name, factory };
